import React from "react";

export function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#1a1008" d="M12 11v3.2h5.3c-.2 1.3-.9 2.4-1.9 3.1l3 2.3c1.8-1.6 2.8-4 2.8-6.9 0-.7-.1-1.3-.2-1.9H12z"/>
      <path fill="#1a1008" d="M5.3 14.3l-.7.5L2 17c1.7 3.3 5.1 5.5 9 5.5 2.7 0 5-1 6.7-2.5l-3-2.3c-.9.6-2 .9-3.7.9-2.9 0-5.3-1.9-6.2-4.5l-.5.2z"/>
      <path fill="#1a1008" d="M2 7l3.3 2.5C6.2 6.9 8.6 5 11.5 5c1.6 0 3 .6 4.1 1.6l2.6-2.6C16.5 2.4 14.2 1.5 11.5 1.5 7.6 1.5 4.2 3.7 2 7z"/>
      <path fill="#1a1008" d="M11.5 22.5c2.7 0 5-.9 6.7-2.5l-3-2.3c-.9.6-2 .9-3.7.9-2.9 0-5.3-1.9-6.2-4.5L2 17c2.2 3.3 5.6 5.5 9.5 5.5z"/>
    </svg>
  );
}

export default function GoogleButton({ children = "Continue with Google" }) {
  const handleClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" className="google-btn" onClick={handleClick} data-testid="google-signin-btn">
      <GoogleIcon />
      <span>{children}</span>
    </button>
  );
}
